const Sounds = {
    pencilSound: require('./pencilCheck.wav'),
    correct: require('./correct.wav'),
    wrong: require('./wrong.wav'),
    reproved: require('./reproved.wav'),
    levelUp: require('./levelUp.wav'),
    newMessage: require('./newMessage.mp3')
};

const PlaySound = (id) => {
    const SoundEffect = new Audio();
    SoundEffect.src = Sounds[id];
    SoundEffect.play();
};

export default PlaySound;



// WEBPACK FOOTER //
// ./src/sounds/playSound.js